import { type ContainerConfiguration, type CSWSupportedCultureCode, type Whitelabel } from '@lmn/common-search-widget';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider';
import { HEADER_HEIGHT } from '@/app/common/constants.ts';
import { Environment } from '@/domainLogic/index.ts';
import { ENVIRONMENT_NAME } from '@/server/environment.ts';
import getTheme from './getTheme';
import getCSWTabId from './adapters/getCSWTabId';

const useConfiguration = (): ContainerConfiguration => {
  const {
    localization: { locale, themeName, brand, environments, whiteLabelName },
    searchInfoData: { searchMode },
  } = usePageWrapperData();
  const env = environments[ENVIRONMENT_NAME.APP] === Environment.QA ? 'qa' : 'prod';

  return {
    collapseConfiguration: {
      isEnabled: true,
      topOffset: {
        desktop: HEADER_HEIGHT(brand, false),
        mobile: HEADER_HEIGHT(brand, true),
      },
      isRevertOnCollapseEnabled: true,
      isFadeEnabled: false,
    },
    env,
    cultureCode: locale as CSWSupportedCultureCode,
    isTabSyncEnabled: true,
    preselectedTabId: getCSWTabId(searchMode),
    theme: getTheme(themeName),
    showBackground: false,
    whitelabel: (whiteLabelName.toLowerCase() || undefined) as Whitelabel | undefined,
  };
};

export default useConfiguration;
